<div class="modal-header">
  <h4 class="modal-title">{{ title | messageTranslate }}</h4>
  <button type="button" ngbAutofocus class="btn-close" aria-label="Close" (click)="onIgnore()"></button>
</div>
<div class="modal-body">
  @if (header) {
    <h5 class="mb-4">{{ header | messageTranslate }}</h5>
  }
  @if (bodyMessages?.length) {
    <div class="row">
      <div class="col mb-5">
        <!-- TODO: KQ: improve track property -->
        @for (bodyMessage of bodyMessages; track bodyMessage) {
          {{ bodyMessage | messageTranslate }}
        }
      </div>
    </div>
  }
  @if (items?.length) {
    <!-- TODO: KQ: improve track property -->
    @for (item of items; track item) {
      <p>{{ item | messageTranslate }}</p>
    }
  }
  @if (messages?.length) {
    <!-- TODO: KQ: improve track property -->
    @for (message of messages; track message) {
      @if (message.type) {
        <ngb-alert [dismissible]="false" [type]="message.type">
          {{ message.message ? (message.message | messageTranslate) : message.text }}
        </ngb-alert>
      } @else {
        <p>{{ message.message ? (message.message | messageTranslate) : message.text }}</p>
      }
    }
  }
  @if (tableConfig?.tableRows?.length && tableConfig?.tableColumns?.length) {
    <app-ace-table [columns]="tableConfig.tableColumns"
                   [rows]="tableConfig.tableRows"
                   [showPageLimitControl]="false"
                   [footerHeight]="0"/>
  }
  @if (messageTemplate) {
    <ng-template [ngTemplateOutlet]="messageTemplate"/>
  }
</div>
<div class="modal-footer">
  <app-button visual="primary" [label]="confirmYesText" [loading]="doingAction" (buttonClick)="onAction()"/>
  @if (!hideCancelButton) {
    <app-button visual="secondary" [label]="cancelText" [disabled]="doingAction" (buttonClick)="onCancel()"/>
  }
</div>

<ng-template #headerTemplate let-column="column">
  <b>{{column.name | messageTranslate}}</b>
</ng-template>

<ng-template #cellTemplate let-value="value">
  {{value}}
</ng-template>
